import React from 'react'

function Card(props) {
  const Icon = props.item.icon;
  const iconIsImage = typeof Icon === "string";

  return (
    <div className={`${props.class}-card`}>
      <div className="face face1">
        <div className="content">
          <div className="has-text-centered why-us-icon-shell">
            {iconIsImage && <img className="card-icon-image" src={Icon} alt="" loading="lazy" decoding="async" />}
            {Icon && !iconIsImage && <Icon aria-hidden="true" />}
          </div>
          <h3>{props.item.moto}</h3>
        </div>
      </div>
      <div className="face face2">
        <div className="content">
        <p>{props.item.desc}</p>
        </div>
      </div>
    </div>
  )
}

export default Card
